import { useCallback } from "react";

import PropTypes from "prop-types";

import { apiClient } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const PromotionCampaignSelect = ({
  value,
  onChange,
  disabled,
  statuses,
  TextFieldProps,
  ...props
}) => {
  const fetchPromotionCampaigns = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("/promotion-campaigns", {
      params: {
        status: statuses,
      },
    });
    return data;
  }, [statuses]);

  return (
    <CustomAutocomplete
      value={value}
      onChange={onChange}
      disabled={disabled}
      fetchOptions={fetchPromotionCampaigns}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      TextFieldProps={{
        label: "Kampanye Promosi",
        placeholder: "Pilih",
        ...TextFieldProps,
      }}
      {...props}
    />
  );
};

PromotionCampaignSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  statuses: PropTypes.arrayOf(PropTypes.string),
  TextFieldProps: PropTypes.object,
};
